import React from 'react';

import { getFileType } from '@/shared/lib/utils/fileType';
import { LoadingState } from '@/shared/ui/states/LoadingState/LoadingState';

import { ImageViewer } from './_internal/ImageViewer';
import { JsonViewer } from './_internal/JsonViewer';
import { ModelSchemaViewer } from './_internal/ModelSchemaViewer';
import { TextViewer } from './_internal/TextViewer';
import { UnsupportedFileViewer } from './_internal/UnsupportedFileViewer';
import styles from './FileViewer.module.css';

type FileViewerProps = {
  path: string;
  type?: string;
  content?: unknown;
  isLoading?: boolean;
  onDownload: () => void;
  embedded?: boolean;
};

type ViewerComponentProps = {
  content: unknown;
};

const VIEWER_MAP: Record<string, React.FC<ViewerComponentProps>> = {
  image: ({ content }) => <ImageViewer url={content as string} />,
  json: ({ content }) => <JsonViewer data={content as object} />,
  text: ({ content }) => <TextViewer content={content as string} />,
  model: ({ content }) => <ModelSchemaViewer yamlContent={content as string} />,
};

export const FileViewer: React.FC<FileViewerProps> = ({
  path,
  type: passedType,
  content,
  isLoading,
  onDownload,
  embedded,
}) => {
  const rootClass = embedded ? styles.viewerEmbedded : styles.viewerContainer;

  if (isLoading) {
    return (
      <div className={rootClass}>
        <LoadingState compact size={32} style={{ height: '100%' }} />
      </div>
    );
  }

  const type = passedType || getFileType(path);

  const renderContent = () => {
    if (type === 'directory') {
      return (
        <div className={styles.directoryView}>
          <div className={styles.directoryIcon} />
          <div className={styles.directoryName}>미리보기할 파일을 선택해 주세요</div>
          <div className={styles.directoryHint}>지원 형식: 이미지, 텍스트, HTML, PDF, 오디오, 비디오, GeoJSON 파일</div>
        </div>
      );
    }

    const Viewer = VIEWER_MAP[type];
    if (Viewer) {
      return <Viewer content={content} />;
    }

    return <UnsupportedFileViewer fileName={path.split('/').pop() || ''} onDownload={onDownload} />;
  };

  return <div className={rootClass}>{renderContent()}</div>;
};
